import { connect } from 'react-redux';
import { branch, compose, renderComponent, lifecycle } from 'recompose';

import { injectIntl } from 'react-intl';
import { isRtl } from 'modules/language/selectors/language';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import {
  changePatientInfoTab,
  openMediaGalleryTab,
} from 'modules/appointmentInfo/actions/changePatientInfoTab';
import { isFABEnabled, isGalleryEnabled } from 'modules/appointmentInfo/selectors/mediaGallery';
import TabContentPending from 'modules/appointmentInfo/components/_placeholders/TabContentPending';
import TabContentFailure from 'modules/appointmentInfo/components/_placeholders/TabContentFailure';
import { selectAndStartUploadMedia } from 'modules/appointmentInfo/actions/uploadConsultationMedia';
import { getAvailableExtensionToUpload } from 'modules/appointmentInfo/utils/getAvailableExtensionToUpload';
import {
  isMissingFiles,
  isMaxUploadsReached,
  getMissingCaseMessage,
  getMissingFilesMessage,
  getMaxFilesReachedMessage,
  getReadCurrentAppointmentPermissions,
} from 'modules/appointmentInfo/selectors/currentAppointment';
import { getTranslations } from 'modules/common/actions/getTranslations';


import InfoTab from './InfoTab';

const mapStateToProps = state => {
  const { requestStatus, fetchGroupedStatus } = state.appointmentInfo.currentAppointment;

  return {
    infoTabId: state.appointmentInfo.infoTab.tabId,
    rtl: isRtl(),
    permissions: getReadCurrentAppointmentPermissions(state),

    galleryEnabled: isGalleryEnabled(state),
    isFABEnabled: isFABEnabled(state),
    acceptedFilesExtensions: getAvailableExtensionToUpload(state),
    missingFilesMessage: getMissingFilesMessage(state),
    maxFilesReachedMessage: getMaxFilesReachedMessage(state),
    isMissingFiles: isMissingFiles(state),
    isMaxUploadsReached: isMaxUploadsReached(state),
    missingCaseMessage: getMissingCaseMessage(state),

    isAppointmentInfoFetchFailed: requestsStatuses.failure === requestStatus,
    isAppointmentFetching:
      [requestsStatuses.pending].includes(fetchGroupedStatus) ||
      [requestsStatuses.default, requestsStatuses.pending].includes(requestStatus),
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      changePatientInfoTab,
      selectAndStartUploadMedia,
      openMediaGalleryTab,
      getTranslations,
    },
  ),

  branch(
    ({ isAppointmentInfoFetchFailed }) => isAppointmentInfoFetchFailed,
    renderComponent(TabContentFailure),
  ),

  branch(
    ({ isAppointmentFetching }) => isAppointmentFetching,
    renderComponent(TabContentPending),
  ),

  lifecycle({
    componentDidMount() {
      this.props.getTranslations(['FILES_PREREQUISITES_MAX_UPLOADED_MESSAGE', 'FILES_PREREQUISITES_NOTIFICATION_MESSAGE']);
    },
  }),
  injectIntl,
)(InfoTab);
